import React, { useEffect } from 'react';
import clsx from 'clsx'
import Card from '@mui/material/Card';
import BusinessIcon from '@mui/icons-material/Business';
import { Avatar, Typography, CardContent, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles'
import theme from './../../../../theme'

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 10,
    marginRight: 10,
    minHeight: 120,
    minWidth: 300
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.main
  }
}));

const CustomAvatar = styled(Avatar)({
  height: 45,
  width: 45,
  backgroundColor: '#F2D647',
  [theme.breakpoints.down('md')]: {
    height: 35,
    width: 35,
    display: 'flex'
  },
})

const CardEmpresas = (props) => {
  const { className, ...rest } = props
  const classes = useStyles();
  const dispatch = useDispatch();

  const totalEmpresas = useSelector((state) => (state.dashboard ? state.dashboard.dashboard.totalEmpresas : undefined))

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justifyContent="space-between">
          <Grid item styles={{ display: 'flex', flexDirection: 'column' }}>
            <Grid item>
            <Typography variant="h5" className={classes.title}>
                {totalEmpresas ? totalEmpresas : 0}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" gutterBottom>
                Total de empresas cadastradas
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <CustomAvatar>
              <BusinessIcon sx={{ fontSize: 20, color: '#fff' }} />
            </CustomAvatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card >
  );
}

CardEmpresas.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string
}

export default CardEmpresas
